export const tPath = 'currentWeatherConditionsPage.alertDetails.';
